@import 'styles/variables';

.snippetPreview {
  background-color: $navy-5;
  box-shadow: inset -1px 0px 0px #c2c7d1;
  padding-right: 12px;
}
